<template>
  <div style="display: flex; flex-direction: column; gap: 10px">
    <div
        v-if="isFiltersOpen"
        style="
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: 40px;
          "
    >
      <div>
        <span style="margin-right: 10px">Alarm ID</span>
        <InputText v-model="alarmPointId" placeholder="Filter by Alarm ID"/>
      </div>

      <div>
        <span style="margin-right: 10px">System ID</span>
        <InputText v-model="systemId" placeholder="Filter by System ID"/>
      </div>
    </div>
    <DataTable :value="modules"
               :paginatorTemplate="'FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink'"
               :paginator="true"
               :page="apCurrentPage"
               :dataKey="tableDataKey"
               :rows="alarmPointRows"
               :scrollable="true"
               :lazy="true"
               :totalRecords="apTotalRecords"
               @page="setApCurrentPage"
               class="tight"
    >
      <Column
          header="ID"
          :style="'width: 100%' + '%; word-break: break-all; min-height: 38px;'"
          field="id"
          header-style="padding-left: 19px!important;"
      >
        <template #body="slotProps">
            <span style="word-break: break-all; padding-left: 5px"
            >
              {{ slotProps.data.id }}
            </span>

        </template>
      </Column>
      <Column
          header="Mid"
          style="width: 100%; word-break: break-all; min-height: 38px;"
          field="mid"
          header-style="padding-left: 19px!important;"
      >
        <template #body="slotProps">
            <span style="text-align: center; word-break: break-all; padding-left: 5px"
            >
              {{ slotProps.data.mid }}
            </span>

        </template>
      </Column>
      <Column
          header="Connected"
          style="width: 100%; word-break: break-all; min-height: 38px;"
          field="connected"
          header-style="padding-left: 19px!important;"
      >
        <template #body="slotProps">
            <span style="text-align: center; word-break: break-all; padding-left: 5px"
            >
              {{ slotProps.data.connected }}
            </span>

        </template>
      </Column>
      <template #empty> No alarms found</template>
    </DataTable>
  </div>
</template>

<script>
import {getLicenseModules} from "@/api/license";
import {debounce} from "lodash";

export default {
  name: "license",
  props: {
    isFiltersOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      alarmPointId: "",
      systemId: "",
      modules: [],
      isLoading: false,
      alarmPointRows: 15,
      apCurrentPage: 0,
      apTotalRecords: 0,
      tableDataKey: null,
    };
  },
  created() {
    this.debouncedFilterUpdate = debounce(this.getLicenseModulesList, 500);
  },
  mounted() {
    this.getLicenseModulesList();
  },
  watch: {
    alarmPointId() {
      this.debouncedFilterUpdate();
    },
    systemId() {
      this.debouncedFilterUpdate();
    },
  },
  methods: {
    getLicenseModulesList() {
      this.isLoading = true;
      return getLicenseModules().then((response) => {
        this.modules = response.data;
        this.isLoading = false;
      });
    },
    setApCurrentPage({ page }) {
      this.apCurrentPage = page;
      this.isLoading = true;
      this.getLicenseModulesList();
    },
  },
};
</script>
